import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

const MenuItemTradeDataIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.125 14.25C17.125 14.4158 17.0592 14.5747 16.9419 14.6919C16.8247 14.8092 16.6658 14.875 16.5 14.875H1.5C1.33424 14.875 1.17527 14.8092 1.05806 14.6919C0.940848 14.5747 0.875 14.4158 0.875 14.25C0.875 14.0842 0.940848 13.9253 1.05806 13.8081C1.17527 13.6908 1.33424 13.625 1.5 13.625H2.125V8.625C2.125 8.45924 2.19085 8.30027 2.30806 8.18306C2.42527 8.06585 2.58424 8 2.75 8H4.625C4.79076 8 4.94973 8.06585 5.06694 8.18306C5.18415 8.30027 5.25 8.45924 5.25 8.625V13.625H6.5V4.875C6.5 4.70924 6.56585 4.55027 6.68306 4.43306C6.80027 4.31585 6.95924 4.25 7.125 4.25H9.625C9.79076 4.25 9.94973 4.31585 10.0669 4.43306C10.1842 4.55027 10.25 4.70924 10.25 4.875V13.625H11.5V1.125C11.5 0.95924 11.5658 0.800269 11.6831 0.683058C11.8003 0.565848 11.9592 0.5 12.125 0.5H15.25C15.4158 0.5 15.5747 0.565848 15.6919 0.683058C15.8092 0.800269 15.875 0.95924 15.875 1.125V13.625H16.5C16.6658 13.625 16.8247 13.6908 16.9419 13.8081C17.0592 13.9253 17.125 14.0842 17.125 14.25Z"
          fill="#6B7280"
        />
      </svg>
    </SvgIcon>
  );
};

export default MenuItemTradeDataIcon;
